<div class="app-dialog audit-log-details-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ "details" | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <div class="section" *ngIf="formattedMetadata">
      <div class="section-title">metadata</div>
      <pre>{{ formattedMetadata }}</pre>
    </div>

    <div class="section" *ngIf="formattedBefore">
      <div class="section-title">before</div>
      <pre>{{ formattedBefore }}</pre>
    </div>

    <div class="section" *ngIf="formattedAfter">
      <div class="section-title">after</div>
      <pre>{{ formattedAfter }}</pre>
    </div>

    <div class="section">
      <div class="section-title">full log</div>
      <pre>{{ formattedLog }}</pre>
    </div>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()">{{ "close" | translate }}</button>
  </footer>
</div>
